import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signOut,
  signInWithCustomToken,
  onIdTokenChanged,
  onAuthStateChanged,
  getIdToken,
  getIdTokenResult,
} from 'firebase/auth';
import { isServer, settings } from '../settings';
import { documentGetCookie } from '../cookie';

const app = initializeApp({
  apiKey: settings.AUTH_API_KEY,
  authDomain: settings.AUTH_DOMAIN,
  appId: settings.AUTH_APP_ID,
});

const auth = getAuth(app);

export const refreshAccessToken = () => getIdTokenResult(auth.currentUser, true);

export const getAccessToken = async () => {
  if (isServer) return Promise.resolve(null);
  if (auth.currentUser) return getIdToken(auth.currentUser);

  await new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });

  return auth.currentUser
    ? getIdToken(auth.currentUser)
    : documentGetCookie('access_token') || null;
};

export const signOutFirebase = () => signOut(auth);

export const signInFirebase = (token) => signInWithCustomToken(auth, token);

export const onChangeIdToken = (observer) => onIdTokenChanged(auth, observer);

export const onChangeAuthState = (observer) => onAuthStateChanged(auth, observer);
